import { FC } from "preact/compat";
import { NavLink } from "react-router-dom";
import { getMe } from "~/core";
import ManagementIcon from "@material-design-icons/svg/outlined/settings.svg";
import AssignmentIcon from "@material-design-icons/svg/outlined/assignment.svg";
import MilestonesIcon from "@material-design-icons/svg/outlined/calendar_today.svg";
import OverviewIcon from "@material-design-icons/svg/outlined/equalizer.svg";
import KanbanIcon from "@material-design-icons/svg/outlined/view_kanban.svg";
import InboxIcon from "@material-design-icons/svg/outlined/inbox.svg";
import cn from "classnames";

const getLink = (path: string, Icon: FC, label: string) => (
    <NavLink
        to={path}
        key={path}
        aria-label={label}
        className={({ isActive }: { isActive: boolean }) =>
            cn(
                "flex justify-center w-full py-3 transition duration-100 hover:bg-white hover:bg-opacity-25 relative outline-white h-[44px] fill-gray-200",
                isActive ? "bg-white bg-opacity-25" : ""
            )
        }
    >
        {({ isActive }: { isActive: boolean }) => (
            <>
                {isActive && (
                    <div className="absolute top-0 left-0 w-1 h-full bg-white" />
                )}
                <Icon />
            </>
        )}
    </NavLink>
);

const Menu: FC = () => {
    const { role } = getMe();

    return (
        <div className="w-[50px] min-w-[50px] bg-[#29465B] flex flex-col justify-between relative z-40">
            <ul className="flex flex-col items-center">
                {role.value !== "none" &&
                    getLink("/me/kanban", KanbanIcon, "Kanban")}
                {role.value !== "none" &&
                    getLink("/me/tasks", AssignmentIcon, "Tasks")}
                {role.value !== "none" &&
                    getLink("/me/milestones", MilestonesIcon, "Milestones")}
                {role.value !== "none" &&
                    getLink("/me/overview", OverviewIcon, "Overview")}
                {role.value !== "none" &&
                    getLink("/me/inbox", InboxIcon, "Inbox")}
            </ul>
            <ul className="flex flex-col items-center">
                {role.value === "admin" &&
                    getLink("/me/a/manage", ManagementIcon, "Management")}
            </ul>
        </div>
    );
};

export default Menu;
